import React from "react";
import { useNavigate } from "react-router-dom";
import { Wordmark } from "@/components/Brand";
import { Tablet, ShieldCheck } from "lucide-react";

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 pad-safe">
      <div className="w-full max-w-md fadeup">
        <div className="text-center mb-10">
          <div className="wordmark text-5xl text-[color:var(--olive)]">PATRIA</div>
          <div className="text-xs tracking-[0.4em] text-[color:var(--muted)] uppercase mt-2">Count &amp; Deposit</div>
          <p className="mt-5 text-[color:var(--ink-2)]">Dual-control offering count &amp; Brinks deposit logging.</p>
        </div>

        <button
          className="card w-full p-6 mb-4 flex items-center gap-4 text-left active:scale-[0.99] transition-transform"
          onClick={() => nav("/counter")}
          data-testid="enter-counter"
        >
          <div className="w-12 h-12 rounded-xl bg-[color:var(--olive)] flex items-center justify-center shrink-0">
            <Tablet className="text-white" />
          </div>
          <div>
            <div className="font-semibold text-lg">Count Room (iPad)</div>
            <div className="text-sm text-[color:var(--ink-2)]">Counters sign in with username &amp; PIN</div>
          </div>
        </button>

        <button
          className="card w-full p-6 flex items-center gap-4 text-left active:scale-[0.99] transition-transform"
          onClick={() => nav("/login")}
          data-testid="enter-staff"
        >
          <div className="w-12 h-12 rounded-xl bg-[color:var(--sage)] flex items-center justify-center shrink-0">
            <ShieldCheck className="text-white" />
          </div>
          <div>
            <div className="font-semibold text-lg">Staff &amp; Finance</div>
            <div className="text-sm text-[color:var(--ink-2)]">Admin, Coordinator &amp; Auditor sign in</div>
          </div>
        </button>
      </div>
    </div>
  );
}
